import { render } from "./ViewStudentVerificationDialog.vue?vue&type=template&id=5f03ebd3"
import script from "./ViewStudentVerificationDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentVerificationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__